var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22134_57936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 5.71239C1.3335 4.91494 1.65508 4.42622 2.32058 4.05586L5.06008 2.5313C6.49556 1.73244 7.21331 1.33301 8.00016 1.33301C8.78702 1.33301 9.50476 1.73244 10.9402 2.5313L13.6797 4.05586C14.3452 4.42622 14.6668 4.91494 14.6668 5.71239C14.6668 5.92863 14.6668 6.03675 14.6432 6.12564C14.5192 6.59264 14.096 6.66634 13.6873 6.66634L2.31302 6.66634C1.90434 6.66634 1.48118 6.59264 1.35711 6.12564C1.3335 6.03675 1.3335 5.92863 1.3335 5.71239Z",
    stroke: "#242428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 6.66602L2.66699 12.3327M5.33366 6.66602L5.33366 12.3327",
    stroke: "#242428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 12.333L3.3335 12.333C2.22893 12.333 1.3335 13.2284 1.3335 14.333C1.3335 14.5171 1.48273 14.6663 1.66683 14.6663L7.3335 14.6663",
    stroke: "#242428",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3335 9.66634L9.66683 14.333",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.167,
    cy: 10.166,
    r: 0.5,
    stroke: "#242428"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8335,
    cy: 13.833,
    r: 0.5,
    stroke: "#242428"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22134_57936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTax);
export default __webpack_public_path__ + "static/media/icon-tax.a1872574426c2174b3d52d29665b3278.svg";
export { ForwardRef as ReactComponent };